import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;

  width: 35vw;
  height: 65vh;

  justify-content: center;

  background-color: white;

  border-radius: 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  .header {
    display: flex;
    position: relative;

    height: 10%;

    align-items: center;
    justify-content: center;

    font-size: 1.5rem;
    font-family: "Mulish";
    font-weight: bold;

    padding: 1rem;

    border-bottom: 1px solid #c4c4c4;
    .back-icon {
      position: absolute;

      left: 1rem;

      cursor: pointer;
    }
  }

  // FINAL DO HEADER

  .user-identification {
    display: flex;

    height: 15%;

    padding: 0.5rem;

    border-bottom: 1px solid #c4c4c4;

    justify-content: space-between;

    .infos {
      display: flex;
      flex-direction: column;

      width: 35%;

      justify-content: space-between;

      font-size: 1.2rem;

      .info-wrapper {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      .info-wrapper > p {
        font-size: 1.1rem;

        color: black;

        white-space: nowrap;
      }
    }
  }

  form {
    height: 75%;
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;

    height: 100%;

    align-items: center;
    justify-content: space-evenly;

    padding: 1rem;
  }

  .inputs-wrapper {
    display: flex;
    flex-direction: column;

    height: 80%;
    width: 80%;

    align-items: center;

    gap: 0.5rem;

    input {
      border: 2px solid #3751ff;
      border-radius: 1rem;

      width: 100%;
      height: 3rem;

      font-size: 1.2rem;

      padding: 0.5rem;

      ::placeholder {
        font-size: 1.2rem;
        font-weight: 500;

        color: black;

        vertical-align: middle;
      }
    }

    .input-error {
      border: solid 2px red;
    }
  }

  .wrapper {
    display: flex;

    width: 100%;
    height: 5rem;

    justify-content: space-between;
  }

  .wrapper-error {
    display: flex;
    flex-direction: column;

    width: 100%;
  }

  .pass-wrapper-error {
    display: flex;
    flex-direction: column;

    width: 45%;
  }

  .pass-wrapper {
    width: 45%;
  }

  .select-content {
    display: flex;

    width: 100%;
    height: 4rem;

    gap: 1rem;
    padding: 0 0 0 1rem;

    background-color: #3751ff;

    border-radius: 1rem;

    align-items: center;

    color: white;

    p {
      font-weight: bold;
    }
  }

  .button-wrapper {
    display: flex;

    width: 100%;

    justify-content: center;
    input {
      display: flex;

      align-items: center;
      justify-content: center;

      width: 40%;
      height: 3rem;

      background-color: #3751ff;
      color: white;

      font-size: 1.1rem;

      border: none;
      border-radius: 0.5rem;

      cursor: pointer;
      transition: 400ms;

      :hover {
        width: 50%;

        font-size: 1.3rem;
      }
    }
  }

  .error-wrapper {
    display: flex;

    width: 100%;
    height: 2rem;

    align-items: center;

    svg {
      width: 10%;
      height: 75%;
    }
  }

  .pass-wrapper-error {
    display: flex;
    flex-direction: column;

    width: 45%;

    align-items: center;
  }

  .pass-error-wrapper {
    display: flex;

    width: 100%;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      :hover {
        overflow: visible;

        white-space: normal;
      }
    }
  }
`;
